import http from "../../http-common"
import { pageSizeType, sortByType } from "../../redux/slice/news-articles/news-articles-search-slice";

class NewsArticlesSearchAuthorsServices {
    getAllNewsArticlesAuthors() {
        return http.get('news-articles-search/authors')
    }
}


export default new NewsArticlesSearchAuthorsServices();